import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField2 from 'components/TextField2';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@material-ui/core';
import formStyles, { gridStyle, Row, RowInner, ColCard, Fills } from 'utils/formStyles';
import Checkbox2 from 'components/Checkbox2';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import { getService } from 'reducers/service';
import { notify } from 'reducers/NotifierReducer';
import { handleError } from 'reducers/ErrorReducer';
import FormDivider from 'components/FormDivider';
import Autocomplete2 from 'components/Autocomplete2';
import { getAgency } from 'Settings/Agencies/AgencyFunctions';
import { getExampleID } from 'global-components/CustomIDGenerator/customIDHelper';
import CitationFileInfo from 'Settings/Mobile/CitationFileInfo';
import CustomEvidence from 'Settings/CustomEvidence';
import CustomCases from 'Settings/CustomCases';
import CustomCitation from 'Settings/CustomCitation';
import CloseIcon from '@material-ui/icons/Close';
import DatePicker2 from 'components/DatePicker2';
import moment from 'moment-timezone';
import { Grid } from '@mui/material';

const useStyles = makeStyles(theme => ({
  ...formStyles,
  wrap: {
    padding: theme.spacing(3),
  },
  item: gridStyle(200, 320),
  btn: {
    marginTop: theme.spacing(3),
    display: 'block',
    marginRight: 0,
    marginLeft: 'auto',
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
  txtfield: {
    width: '100%',
    marginTop: '8px !important',
    marginBottom: '0px !important',
  },
  txtfield2: {
    width: '100%',
    marginBottom: '0px !important',
  },
  select: {
    marginTop: '8px !important',
    marginBottom: '0px !important',
    marginLeft: '0px !improtant',
    width: '100%',
  },
}));

const agencyOriValidationRules = {
  LA: {
    expression: /^LA[A-Za-z0-9]{5}00$/,
    message: 'ORI must be a 9-character alphanumeric code starting with "LA" and ending with "00".',
  },
};

const RECOMMENDED_SID_VALIDATION = 'Recommended';

function AgencyRms(props) {
  const { agencyId } = props;
  const classes = useStyles();
  const service = getService('settings-agency-rms');
  const identifierService = getService('pts-custom-agency-id');
  const citationExportMethods = [
    { Code: 'ONSAVE', Description: 'Export when saved' },
    { Code: 'CITATIONBUTTON', Description: 'Manual export' },
  ];
  const [courtTitle, setCourtTitle] = useState('');
  const [ibrReporting, setIbrReporting] = useState('IBR Only');
  const [ucrRape, setUcrRape] = useState('New');
  const [ucrHate, setUcrHate] = useState('Monthly');
  const [agencyName, setAgencyName] = useState('');
  const [baseDate, setBaseDate] = useState('');
  const [atnOri, setAtnOri] = useState('');
  const [defaultComplaintID, setDefaultComplaintID] = useState('');
  const [defaultOffenderID, setDefaultOffenderID] = useState('');
  const [defaultOffenseCode, setDefaultOffenseCode] = useState('');
  const [showImport, setShowImport] = useState(false);
  const [sharedNumbers, setSharedNumbers] = useState(false);
  const [viewNarratives, setViewNarratives] = useState(false);
  const [importDefault, setImportDefault] = useState(false);
  const [userDefined, setUserDefined] = useState(false);
  const [dontPrintSSN, setDontPrintSSN] = useState(false);
  const [printArrestSign, setPrintArrestSign] = useState(false);
  const [dontPrintPOB, setDontPrintPOB] = useState(false);
  const [collegeAgency, setCollegeAgency] = useState(false);
  const [hideJuvInc, setHideJuvInc] = useState(false);
  const [enableIncDef, setEnableIncDef] = useState(false);
  const [enableImportSelect, setEnableImportSelect] = useState(false);
  const [enablePrintOther, setEnablePrintOther] = useState(false);
  const [enablePrintChoice, setEnablePrintChoice] = useState(false);
  const [enablePopup, setEnablePopup] = useState(false);
  const [allowSupplement, setAllowSupplement] = useState(false);
  const [disableApproval, setDisableApproval] = useState(false);
  const [requireArrest, setRequireArrest] = useState(false);
  const [richText, setRichText] = useState(false);
  const [enableOfficer, setEnableOfficer] = useState(false);
  const [openNarratives, setOpenNarratives] = useState(false);
  const [enableExpunge, setEnableExpunge] = useState(false);
  const [enableUnknown, setEnableUnknown] = useState(false);
  const [disablePress, setDisablePress] = useState(false);
  const [disableAutoStatus, setDisableAutoStatus] = useState(false);
  const [overridePrint, setOverridePrint] = useState(false);
  const [oriError, setOriError] = useState(false);
  const [allowLegacyExport, setAllowLegacyExport] = useState(false);
  const [nibrsVersion, setNibrsVersion] = useState('NIBRS');
  const [submissionFileFormat, setSubmissionFileFormat] = useState('SINGLE');
  const [citationExportMethod, setCitationExportMethod] = useState(
    citationExportMethods.find(x => x.Code === 'CITATIONBUTTON')
  );
  const [IncidentReportVersion, setIncidentReportVersion] = useState(null);
  const [EvidenceLabelReportVersion, setEvidenceLabelReportVersion] = useState(null);
  const [incidentExId, setIncidentExId] = useState('');
  const [citationExId, setCitationExId] = useState('');
  const [evidenceExId, setEvidenceExId] = useState('');
  const [showIncidentDialog, setshowIncidentDialog] = useState(false);
  const [showCitationDialog, setshowCitationDialog] = useState(false);
  const [showEvidenceDialog, setshowEvidenceDialog] = useState(false);
  const [dataBrokerEnabled, setDataBrokerEnabled] = useState(false);
  const [enableRealTimeIbrSubmission, setEnableRealTimeIbrSubmission] = useState(false);
  const [sendValidReportsOnApproval, setSendValidReportsOnApproval] = useState(false);
  const [isTexasAgency, setIsTexasAgency] = useState(false);
  const [dataBrokerBaseUrl, setDataBrokerBaseUrl] = useState('');
  const [dataBrokerAccessId, setDataBrokerAccessId] = useState('');
  const [dataBrokerSecret, setDataBrokerSecret] = useState('');
  const [DefaultCustodyRecord, setDefaultCustodyRecord] = useState(null);
  const [enableDASubmission, setEnableDASubmission] = useState(false);
  const [dispositionTypes, setDispositionTypes] = useState([]);
  const [disposition, setDisposition] = useState(null);
  const [pendingDispositionCode, setPendingDispositionCode] = useState(null);
  const [sidValidation, setSidValidation] = useState(null);

  const citationExportError = allowLegacyExport && !citationExportMethod?.Code;
  const SubmissionFileFormats = [
    { Code: 'SINGLE', Description: 'Single File' },
    { Code: 'ZIPPED', Description: 'Zipped File' },
  ];
  const NibrsVersions = useSelector(state => state.dictionary.codeNibrsVersions);

  const codeIncidentReportVersions = useSelector(
    state => state.dictionary.codeIncidentReportVersions
  );
  const codeEvidenceLabelReportVersions = useSelector(
    state => state.dictionary.codeEvidenceLabelReportVersions
  );
  const codeDispositions = useSelector(state => state.dictionary.Dispositions);
  const codeArrestedPartySIDValidationTypes = useSelector(
    state => state.dictionary.codeArrestedPartySIDValidationTypes
  );

  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    const defination = agencyOriValidationRules[nibrsVersion?.Code];

    if (defination) {
      if (defination.expression.test(atnOri)) {
        setOriError(false);
      } else {
        setOriError(defination.message);
      }
    } else {
      if (atnOri.length !== 9) {
        setOriError('ATN ORI should be 9 characters');
      } else {
        setOriError(false);
      }
    }
  }, [nibrsVersion, atnOri]);

  useEffect(() => {
    if (!codeDispositions) return;
    setDispositionTypes(
      codeDispositions
        .filter(disp => disp?.AgencyID === agencyId)
        .map(disp => ({ Code: disp?.Code, Description: disp?.Description })) || []
    );
  }, [codeDispositions]);

  useEffect(() => {
    if (!dispositionTypes.length || !pendingDispositionCode) return;
    setDisposition(dispositionTypes.find(rel => rel.Code === pendingDispositionCode) || null);
  }, [dispositionTypes, pendingDispositionCode]);

  useEffect(() => {
    const isTxAgency = (
      nibrsVersion === 'TX' || (typeof nibrsVersion === 'object' && nibrsVersion?.Code === 'TX')
    );
    setIsTexasAgency(isTxAgency);
    if (!isTxAgency) {
      setEnableRealTimeIbrSubmission(false);
      setSendValidReportsOnApproval(false);
    }
  }, [nibrsVersion]);

  const search = async () => {
    const result = await service.get(agencyId);
    renderInitial(result);
    const agencyData = await getAgency(agencyId);
    const { IncidentReportVersion, EvidenceLabelReportVersion, DefaultCustodyRecord } = agencyData;
    setIncidentReportVersion(
      codeIncidentReportVersions?.find(type => type?.Code === IncidentReportVersion) || null
    );
    setEvidenceLabelReportVersion(
      codeEvidenceLabelReportVersions?.find(type => type?.Code === EvidenceLabelReportVersion) ||
        null
    );
    setDefaultCustodyRecord(agencyData?.DefaultCustodyRecord);
    setDispositionTypes(
      codeDispositions
        ?.filter(disp => disp?.AgencyID === agencyId)
        ?.map(disp => ({ Code: disp?.Code, Description: disp?.Description })) || []
    );
    const sidValidation = result?.find(item =>
      item?.Path?.includes('.RMS.DASubmission.ArrestedPartySIDValidation')
    );
    if (!sidValidation) {
      setSidValidation(
        codeArrestedPartySIDValidationTypes?.find(item => item?.Code === RECOMMENDED_SID_VALIDATION)
      );
    }
    await getIdentifier('RMS', agencyId, 'Citation (Agency Specific)', setCitationExId);
    await getIdentifier('Global', agencyId, 'Cases (Agency Specific)', setIncidentExId);
    await getIdentifier('RMS', agencyId, 'Evidence (Agency Specific)', setEvidenceExId);
  };

  const getIdentifier = async (application, agencyId, entityName, setfn) => {
    identifierService
      .get({ Application: application, AgencyID: agencyId, EntityName: entityName })
      .then(res => setfn(getExampleID(res[0])))
      .catch(err => console.log(err));
  };

  const renderInitial = data => {
    for (const row of data) {
      const { Path } = row;
      switch (true) {
        case Path.includes('.RMS.CourtTitle'):
          setCourtTitle(row.ValueString || '');
          break;
        case Path.includes('.RMS.IBR.UCR.Reporting'):
          setIbrReporting(row.ValueString || '');
          break;
        case Path.includes('.RMS.UCR.RapeDefinition'):
          setUcrRape(row.ValueString || '');
          break;
        case Path.includes('.RMS.UCR.HateCrimeReportingPeriod'):
          setUcrHate(row.ValueString || '');
          break;
        case Path.includes('.RMS.AgencyName'):
          setAgencyName(row.ValueString || '');
          break;
        case Path.includes('.RMS.NIBRS.NibrsVersion'):
          setNibrsVersion(NibrsVersions?.find(rel => rel.Code === row.ValueString) || null);
          break;
        case Path.includes('.RMS.NIBRS.SubmissionFileFormat'):
          setSubmissionFileFormat(
            SubmissionFileFormats?.find(rel => rel.Code === row.ValueString) || null
          );
          break;
        case Path.includes('.RMS.BaseDate'):
          setBaseDate(row.ValueDateTime || null);
          break;
        case Path.includes('.RMS.ATN.ORI'):
          setAtnOri(row.ValueString || '');
          if (row.ValueString.length !== 9) setOriError(true);
          break;
        case Path.includes('.RMS.DefaultComplainID'):
          setDefaultComplaintID(row.ValueString || '');
          break;
        case Path.includes('.RMS.DefaultOffenderID'):
          setDefaultOffenderID(row.ValueString || '');
          break;
        case Path.includes('.RMS.DefaultOffenseCode'):
          setDefaultOffenseCode(row.ValueString || '');
          break;
        case Path.includes('.RMS.ShowImportFromCAD'):
          setShowImport(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.SharedNumbers'):
          setSharedNumbers(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.ViewNarrativeWithPasswords'):
          setViewNarratives(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.ImportDefaultAgencySpecific'):
          setImportDefault(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.UserDefinedWarrantNumbers'):
          setUserDefined(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.DontPrintSSN'):
          setDontPrintSSN(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.PrintArrestSign'):
          setPrintArrestSign(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.DontPrintPOB'):
          setDontPrintPOB(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.CollegeAgency'):
          setCollegeAgency(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.HideJuvenileIncidents'):
          setHideJuvInc(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnableIncidentDefaults'):
          setEnableIncDef(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnableImportSelect'):
          setEnableImportSelect(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnablePrintOther'):
          setEnablePrintOther(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnablePrintChoice'):
          setEnablePrintChoice(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnablePopup'):
          setEnablePopup(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.AllowSupplement'):
          setAllowSupplement(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.DisableApproval'):
          setDisableApproval(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.RequireArrest'):
          setRequireArrest(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnableOfficer'):
          setEnableOfficer(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.OpenNarratives'):
          setOpenNarratives(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnableExpunge'):
          setEnableExpunge(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.EnableUnknown'):
          setEnableUnknown(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.DisablePress'):
          setDisablePress(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.DisableAutoStatus'):
          setDisableAutoStatus(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.OverridePrint'):
          setOverridePrint(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.RichText'):
          setRichText(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.AllowCitationLegacyExport'):
          setAllowLegacyExport(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.Citation.ExportMethod'):
          setCitationExportMethod(
            citationExportMethods.find(x => x.Code === row.ValueString) || citationExportMethods[1]
          );
          break;
        case Path.includes('.RMS.NIBRS.DataBroker.Enabled'):
          setDataBrokerEnabled(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.NIBRS.RealTimeIBRSubmission.Enabled'):
          setEnableRealTimeIbrSubmission(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.NIBRS.SendValidReportsOnApproval'):
          setSendValidReportsOnApproval(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.NIBRS.DataBroker.BaseUrl'):
          setDataBrokerBaseUrl(row.ValueString || '');
          break;
        case Path.includes('.RMS.NIBRS.DataBroker.AccessId'):
          setDataBrokerAccessId(row.ValueString || '');
          break;
        case Path.includes('.RMS.NIBRS.DataBroker.Secret'):
          setDataBrokerSecret(row.ValueString || '');
          break;
        case Path.includes('.RMS.DASubmission.Enabled'):
          setEnableDASubmission(row.ValueBoolean || false);
          break;
        case Path.includes('.RMS.DASubmission.DispositionType'):
          setPendingDispositionCode(row.ValueString || null);
          break;
        case Path.includes('.RMS.DASubmission.ArrestedPartySIDValidation'):
          setSidValidation(
            codeArrestedPartySIDValidationTypes?.find(x => x.Code === row.ValueString) ||
              codeArrestedPartySIDValidationTypes?.find(x => x.Code === RECOMMENDED_SID_VALIDATION)
          );
          break;
      }
    }
  };

  const handleSave = async () => {
    const saveObj = formatSaveData();
    try {
      await service.create(saveObj);
      props.notify('Agency RMS Settings Saved.', 'success');
    } catch (err) {
      props.handleError(err, 'Error Saving Agency RMS Settings.');
    }
  };

  const formatSaveData = () => {
    return {
      AgencyID: agencyId,
      IncidentReportVersion: IncidentReportVersion?.Code || null,
      EvidenceLabelReportVersion: EvidenceLabelReportVersion?.Code || null,
      DefaultCustodyRecord: DefaultCustodyRecord,
      Settings: [
        {
          Path: `${agencyId}.RMS.CourtTitle`,
          CDRKey: 'RMS Agency Settings',
          ValueString: courtTitle,
        },
        {
          Path: `${agencyId}.RMS.IBR.UCR.Reporting`,
          CDRKey: 'RMS Agency Settings',
          ValueString: ibrReporting,
        },
        {
          Path: `${agencyId}.RMS.UCR.RapeDefinition`,
          CDRKey: 'RMS Agency Settings',
          ValueString: ucrRape,
        },
        {
          Path: `${agencyId}.RMS.UCR.HateCrimeReportingPeriod`,
          CDRKey: 'RMS Agency Settings',
          ValueString: ucrHate,
        },
        {
          Path: `${agencyId}.RMS.AgencyName`,
          CDRKey: 'RMS Agency Settings',
          ValueString: agencyName,
        },
        {
          Path: `${agencyId}.RMS.NIBRS.NibrsVersion`,
          CDRKey: 'RMS Agency Settings',
          ValueString: nibrsVersion?.Code || null,
        },
        {
          Path: `${agencyId}.RMS.NIBRS.SubmissionFileFormat`,
          CDRKey: 'RMS Agency Settings',
          ValueString: submissionFileFormat?.Code || null,
        },
        {
          Path: `${agencyId}.RMS.BaseDate`,
          CDRKey: 'RMS Agency Settings',
          ValueDateTime: baseDate ? moment(baseDate).format('YYYY-MM-DD') : null,
        },
        {
          Path: `${agencyId}.RMS.ATN.ORI`,
          CDRKey: 'RMS Agency Settings',
          ValueString: atnOri,
        },
        {
          Path: `${agencyId}.RMS.DefaultComplainID`,
          CDRKey: 'RMS Agency Settings',
          ValueString: defaultComplaintID,
        },
        {
          Path: `${agencyId}.RMS.DefaultOffenderID`,
          CDRKey: 'RMS Agency Settings',
          ValueString: defaultOffenderID,
        },
        {
          Path: `${agencyId}.RMS.DefaultOffenseCode`,
          CDRKey: 'RMS Agency Settings',
          ValueString: defaultOffenseCode,
        },
        {
          Path: `${agencyId}.RMS.ShowImportFromCAD`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: showImport,
        },
        {
          Path: `${agencyId}.RMS.SharedNumbers`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: sharedNumbers,
        },
        {
          Path: `${agencyId}.RMS.ViewNarrativeWithPasswords`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: viewNarratives,
        },
        {
          Path: `${agencyId}.RMS.ImportDefaultAgencySpecific`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: importDefault,
        },
        {
          Path: `${agencyId}.RMS.UserDefinedWarrantNumbers`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: userDefined,
        },
        {
          Path: `${agencyId}.RMS.DontPrintSSN`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: dontPrintSSN,
        },
        {
          Path: `${agencyId}.RMS.PrintArrestSign`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: printArrestSign,
        },
        {
          Path: `${agencyId}.RMS.DontPrintPOB`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: dontPrintPOB,
        },
        {
          Path: `${agencyId}.RMS.CollegeAgency`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: collegeAgency,
        },
        {
          Path: `${agencyId}.RMS.HideJuvenileIncidents`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: hideJuvInc,
        },
        {
          Path: `${agencyId}.RMS.EnableIncidentDefaults`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enableIncDef,
        },
        {
          Path: `${agencyId}.RMS.EnableImportSelect`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enableImportSelect,
        },
        {
          Path: `${agencyId}.RMS.EnablePrintOther`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enablePrintOther,
        },
        {
          Path: `${agencyId}.RMS.EnablePrintChoice`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enablePrintChoice,
        },
        {
          Path: `${agencyId}.RMS.EnablePopup`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enablePopup,
        },
        {
          Path: `${agencyId}.RMS.AllowSupplement`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: allowSupplement,
        },
        {
          Path: `${agencyId}.RMS.DisableApproval`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: disableApproval,
        },
        {
          Path: `${agencyId}.RMS.RequireArrest`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: requireArrest,
        },
        {
          Path: `${agencyId}.RMS.RichText`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: richText,
        },
        {
          Path: `${agencyId}.RMS.EnableOfficer`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enableOfficer,
        },
        {
          Path: `${agencyId}.RMS.OpenNarratives`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: openNarratives,
        },
        {
          Path: `${agencyId}.RMS.EnableExpunge`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enableExpunge,
        },
        {
          Path: `${agencyId}.RMS.EnableUnknown`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enableUnknown,
        },
        {
          Path: `${agencyId}.RMS.DisablePress`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: disablePress,
        },
        {
          Path: `${agencyId}.RMS.DisableAutoStatus`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: disableAutoStatus,
        },
        {
          Path: `${agencyId}.RMS.OverridePrint`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: overridePrint,
        },
        {
          Path: `${agencyId}.RMS.AllowCitationLegacyExport`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: allowLegacyExport,
        },
        {
          Path: `${agencyId}.RMS.Citation.ExportMethod`,
          CDRKey: 'RMS Agency Settings',
          ValueString: citationExportMethod?.Code || null,
        },
        {
          Path: `${agencyId}.RMS.NIBRS.DataBroker.Enabled`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: dataBrokerEnabled,
        },
        {
          Path: `${agencyId}.RMS.NIBRS.RealTimeIBRSubmission.Enabled`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enableRealTimeIbrSubmission || false,
        },
        {
          Path: `${agencyId}.RMS.NIBRS.SendValidReportsOnApproval`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: sendValidReportsOnApproval || false,
        },
        {
          Path: `${agencyId}.RMS.NIBRS.DataBroker.BaseUrl`,
          CDRKey: 'RMS Agency Settings',
          ValueString: dataBrokerEnabled ? dataBrokerBaseUrl : '',
        },
        {
          Path: `${agencyId}.RMS.NIBRS.DataBroker.AccessId`,
          CDRKey: 'RMS Agency Settings',
          ValueString: dataBrokerEnabled ? dataBrokerAccessId : '',
        },
        {
          Path: `${agencyId}.RMS.NIBRS.DataBroker.Secret`,
          CDRKey: 'RMS Agency Settings',
          ValueString: dataBrokerEnabled ? dataBrokerSecret : '',
        },
        {
          Path: `${agencyId}.RMS.DASubmission.Enabled`,
          CDRKey: 'RMS Agency Settings',
          ValueBoolean: enableDASubmission,
        },
        {
          Path: `${agencyId}.RMS.DASubmission.DispositionType`,
          CDRKey: 'RMS Agency Settings',
          ValueString: enableDASubmission ? disposition?.Code || null : null,
        },
        {
          Path: `${agencyId}.RMS.DASubmission.ArrestedPartySIDValidation`,
          CDRKey: 'RMS Agency Settings',
          ValueString: enableDASubmission
            ? sidValidation?.Code || RECOMMENDED_SID_VALIDATION
            : RECOMMENDED_SID_VALIDATION,
        },
      ],
    };
  };

  const renderCourtTitle = () => {
    const onChange = (ev, val) => setCourtTitle(val);
    return (
      <TextField2
        className={classes.txtfield}
        label="Court Title"
        value={courtTitle}
        onChange={onChange}
      />
    );
  };

  const renderIbrReporting = () => {
    const handleChange = e => setIbrReporting(e.target.value);
    return (
      <div>
        <FormDivider title="IBR/UCR Reporting" />
        <RowInner>
          <FormControl component="fieldset">
            <RadioGroup value={ibrReporting} onChange={handleChange}>
              <FormControlLabel value="IBR Only" control={<Radio />} label="IBR Only" />
              <FormControlLabel value="UCR Paper Only" control={<Radio />} label="UCR Paper Only" />
              <FormControlLabel
                value="UCR Electronic Only"
                control={<Radio />}
                label="UCR Electronic Only"
              />
              <FormControlLabel
                value="Both IBR/UCR Paper"
                control={<Radio />}
                label="Both IBR/UCR Paper"
              />
              <FormControlLabel
                value="Both IBR/UCR Electronic"
                control={<Radio />}
                label="Both IBR/UCR Electronic"
              />
            </RadioGroup>
          </FormControl>
        </RowInner>
      </div>
    );
  };

  const renderUcrRape = () => {
    const handleChange = e => setUcrRape(e.target.value);
    return (
      <div>
        <FormDivider title="UCR Rape Definition" />
        <RowInner>
          <FormControl component="fieldset">
            <RadioGroup value={ucrRape} onChange={handleChange}>
              <FormControlLabel value="Original" control={<Radio />} label="Original" />
              <FormControlLabel value="New" control={<Radio />} label="New" />
            </RadioGroup>
          </FormControl>
        </RowInner>
      </div>
    );
  };

  const renderUcrHate = () => {
    const handleChange = e => setUcrHate(e.target.value);
    return (
      <div>
        <FormDivider title="UCR Hate Crime Reporting Period" />
        <RowInner>
          <FormControl component="fieldset">
            <RadioGroup value={ucrHate} onChange={handleChange}>
              <FormControlLabel value="Quarterly" control={<Radio />} label="Quarterly" />
              <FormControlLabel value="Monthly" control={<Radio />} label="Monthly" />
            </RadioGroup>
          </FormControl>
        </RowInner>
      </div>
    );
  };

  const renderNibrsReporting = () => {
    const onAtnOriChange = (ev, val = '') => {
      setAtnOri(val);
    };
    return (
      <div>
        <FormDivider title="NIBRS Reporting Settings" />
        <TextField2
          className={classes.txtfield}
          label="Agency Name"
          value={agencyName}
          onChange={(ev, val) => setAgencyName(val)}
        />
        <DatePicker2
          className={classes.txtfield}
          label="Base Date"
          value={baseDate || null}
          onChange={(ev, val) => setBaseDate(val)}
        />
        <TextField2
          className={classes.txtfield}
          label="ATN ORI"
          value={atnOri}
          error={oriError ? oriError : ''}
          onChange={onAtnOriChange}
        />
        <Autocomplete2
          options={NibrsVersions}
          className={classes.select}
          onChange={(ev, val) => setNibrsVersion(val)}
          value={nibrsVersion}
          label="Nibrs version"
        />
        <Box mb={1}>
          <Autocomplete2
            options={SubmissionFileFormats}
            className={classes.select}
            onChange={(ev, val) => setSubmissionFileFormat(val)}
            value={submissionFileFormat}
            label="NIBRS Submission File Format"
          />
        </Box>
        <FormDivider title="Data Broker Settings" />
        <Checkbox2
          checked={dataBrokerEnabled}
          onChange={() => {
            const nextValue = !dataBrokerEnabled;
            setDataBrokerEnabled(nextValue);
            if (!nextValue) {
              setEnableRealTimeIbrSubmission(false);
              setSendValidReportsOnApproval(false);
            }
          }}
          label="Enable Data Broker Submission"
        />
        {dataBrokerEnabled && (
          <>
            <TextField2
              className={classes.txtfield}
              label="Data Broker Base URL"
              value={dataBrokerBaseUrl}
              onChange={(ev, val) => setDataBrokerBaseUrl(val)}
              placeholder="https://databrokeruat.dps.texas.gov"
              error={!dataBrokerBaseUrl?.trim() ? 'Data Broker Base URL is required.' : ''}
            />
            <TextField2
              className={classes.txtfield}
              label="Data Broker Access ID"
              value={dataBrokerAccessId}
              onChange={(ev, val) => setDataBrokerAccessId(val)}
              error={!dataBrokerAccessId?.trim() ? 'Data Broker Access ID is required.' : ''}
            />
            <Box mb={2}>
              <TextField2
                className={classes.txtfield}
                label="Data Broker Secret"
                value={dataBrokerSecret}
                onChange={(ev, val) => setDataBrokerSecret(val)}
                type="password"
                error={!dataBrokerSecret?.trim() ? 'Data Broker Secret is required.' : ''}
              />
            </Box>
          </>
        )}
        {dataBrokerEnabled && isTexasAgency && (
          <Box>
            <Checkbox2
              checked={enableRealTimeIbrSubmission}
              onChange={() => {
                const nextValue = !enableRealTimeIbrSubmission;
                setEnableRealTimeIbrSubmission(nextValue);
                if (!nextValue) {
                  setSendValidReportsOnApproval(false);
                }
              }}
              label="Enable Real Time IBR Submission"
            />
          </Box>
        )}
        {enableRealTimeIbrSubmission && (
          <Box>
            <Checkbox2
              checked={sendValidReportsOnApproval}
              onChange={() => setSendValidReportsOnApproval(!sendValidReportsOnApproval)}
              label="Send Valid Reports on Approval"
            />
          </Box>
        )}
      </div>
    );
  };

  const renderDAReportingSettings = () => {
    return (
      <div>
        <FormDivider title="DA Reporting Settings" />
        <Checkbox2
          checked={enableDASubmission}
          onChange={() => {
            setEnableDASubmission(!enableDASubmission);
          }}
          label="Enable DA Submission"
        />
        {enableDASubmission && (
          <>
            <Box mb={2}>
              <Autocomplete2
                options={dispositionTypes}
                className={classes.select}
                onChange={(ev, val) => setDisposition(val)}
                value={disposition}
                label="DA Submission Disposition Type"
              />
            </Box>
            <Box mb={2}>
              <Autocomplete2
                options={codeArrestedPartySIDValidationTypes}
                className={classes.select}
                onChange={(ev, val) => setSidValidation(val)}
                value={sidValidation}
                label="Arrested Party SID Validation"
              />
            </Box>
          </>
        )}
      </div>
    );
  };

  const renderIncidentReportVersion = () => {
    return (
      <div>
        <FormDivider title="Report Options" />
        <Button
          size="medium"
          variant="contained"
          color="default"
          className="mb-3 ml-1"
          onClick={() => setshowIncidentDialog(true)}>
          Case Number Format: {incidentExId}
        </Button>
        <Autocomplete2
          options={codeIncidentReportVersions}
          className={classes.field}
          onChange={(ev, val) => setIncidentReportVersion(val)}
          value={IncidentReportVersion}
          label="Incident Report Version"
          getOptionLabel={option =>
            `${option.Code} ${option.Description ? '- ' + option.Description : ''}`
          }
          getOptionSelected={(option, value) => option.Code === value.Code}
          renderOption={option =>
            `${option.Code} ${option.Description ? '- ' + option.Description : ''}`
          }
        />
        {showIncidentDialog && (
          <Dialog onClose={closeIncidentDialog} open={true} maxWidth="md">
            <DialogTitle
              style={{ background: '#0153a3', color: 'white' }}
              id="customized-dialog-title"
              onClose={closeIncidentDialog}
              className={classes.title}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <span>Cases Identifier</span>
                <IconButton onClick={closeIncidentDialog} style={{ color: 'white' }} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent className="p-0 h-100">
              <CustomCases agencyID={agencyId} />
            </DialogContent>
          </Dialog>
        )}
      </div>
    );
  };
  const closeIncidentDialog = () => {
    getIdentifier('Global', agencyId, 'Cases (Agency Specific)', setIncidentExId);
    setshowIncidentDialog(false);
  };
  const renderEvidenceLabelReportVersion = () => {
    return (
      <div>
        <FormDivider title="Evidence Options" />
        <Button
          size="medium"
          variant="contained"
          color="default"
          className="mb-3 ml-1"
          onClick={() => setshowEvidenceDialog(true)}>
          Evidence Number Format: {evidenceExId}
        </Button>
        <Box display="flex" gap={2}>
          <div style={{ flex: 1 }}>
            <Autocomplete2
              options={codeEvidenceLabelReportVersions}
              className={classes.field}
              onChange={(ev, val) => setEvidenceLabelReportVersion(val)}
              value={EvidenceLabelReportVersion}
              label="Evidence Label Report Version"
              getOptionLabel={option =>
                `${option.Code} ${option.Description ? '- ' + option.Description : ''}`
              }
              getOptionSelected={(option, value) => option.Code === value.Code}
              renderOption={option =>
                `${option.Code} ${option.Description ? '- ' + option.Description : ''}`
              }
            />
          </div>
          <div style={{ flex: 1 }}>
            <Tooltip
              title="If this field is not blank, 
                            a custody record will automatically be created 
                            when an evidence item is intially checked in.
                            This value will be used as the Custody To for that record."
              arrow>
              <span>
                <TextField2
                  className={classes.txtfield2}
                  label="Evidence Default Custody Check-In"
                  value={DefaultCustodyRecord}
                  onChange={(ev, val) => setDefaultCustodyRecord(val)}
                />
              </span>
            </Tooltip>
          </div>
        </Box>
        {showEvidenceDialog && (
          <Dialog onClose={closeEvidenceDialog} open={true} maxWidth="md">
            <DialogTitle
              style={{ background: '#0153a3', color: 'white' }}
              id="customized-dialog-title"
              onClose={closeEvidenceDialog}
              className={classes.title}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <span>Evidence Identifier</span>
                <IconButton onClick={closeEvidenceDialog} style={{ color: 'white' }} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent className="p-0 h-100">
              <CustomEvidence agencyID={agencyId} />
            </DialogContent>
          </Dialog>
        )}
      </div>
    );
  };
  const closeEvidenceDialog = () => {
    getIdentifier('RMS', agencyId, 'Evidence (Agency Specific)', setEvidenceExId);
    setshowEvidenceDialog(false);
  };
  const renderCitationVersion = () => {
    return (
      <div>
        <FormDivider title="Citation Options" />
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} md={5}>
            <Button
              size="medium"
              variant="contained"
              color="default"
              className="mb-3 ml-1"
              onClick={() => setshowCitationDialog(true)}>
              Citation Number Format: {citationExId}
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            {renderExportToLegacyCitation()}
          </Grid>
          {allowLegacyExport && (
            <Grid item xs={12} md={3}>
              <Autocomplete2
                options={citationExportMethods}
                disabled={!allowLegacyExport}
                onChange={(ev, val) => setCitationExportMethod(val)}
                value={citationExportMethod}
                label="Export Method"
                error={citationExportError ? 'Export Method is required.' : ''}
              />
            </Grid>
          )}
        </Grid>
        <br />
        <FormDivider title="Available Citations" />
        <CitationFileInfo agencyID={agencyId} />
        {showCitationDialog && (
          <Dialog onClose={closeCitationeDialog} open={true} maxWidth="md">
            <DialogTitle
              style={{ background: '#0153a3', color: 'white' }}
              id="customized-dialog-title"
              onClose={closeCitationeDialog}
              className={classes.title}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <span>Citation Identifier</span>
                <IconButton onClick={closeCitationeDialog} style={{ color: 'white' }} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent className="p-0 h-100">
              <CustomCitation agencyID={agencyId} />
            </DialogContent>
          </Dialog>
        )}
      </div>
    );
  };
  const closeCitationeDialog = () => {
    getIdentifier('RMS', agencyId, 'Citation (Agency Specific)', setCitationExId);
    setshowCitationDialog(false);
  };
  const renderShortForm = () => {
    return (
      <div>
        <FormDivider title="Short Form Defaults" />
        <TextField2
          className={classes.txtfield}
          label="Default Complaint ID"
          value={defaultComplaintID}
          onChange={(ev, val) => setDefaultComplaintID(val)}
        />
        <TextField2
          className={classes.txtfield}
          label="Default Offender ID"
          value={defaultOffenderID}
          onChange={(ev, val) => setDefaultOffenderID(val)}
        />
        <TextField2
          className={classes.txtfield}
          label="Default Offense Code"
          value={defaultOffenseCode}
          onChange={(ev, val) => setDefaultOffenseCode(val)}
        />
      </div>
    );
  };

  const renderShowImport = () => {
    const onChange = () => setShowImport(!showImport);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={showImport}
          onChange={onChange}
          label="Show Import From CAD or Incident Program"
        />
      </span>
    );
  };

  const renderSharedNumbers = () => {
    const onChange = () => setSharedNumbers(!sharedNumbers);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={sharedNumbers}
          onChange={onChange}
          label="Shared CAD/Incident Numbers"
        />
      </span>
    );
  };
  const renderViewNarratives = () => {
    const onChange = () => setViewNarratives(!viewNarratives);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={viewNarratives}
          onChange={onChange}
          label="View Narratives With Password"
        />
      </span>
    );
  };
  const renderImportDefault = () => {
    const onChange = () => setImportDefault(!importDefault);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={importDefault}
          onChange={onChange}
          label="Import Default Agency Specific"
        />
      </span>
    );
  };
  const renderUserDefWarrant = () => {
    const onChange = () => setUserDefined(!userDefined);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={userDefined}
          onChange={onChange}
          label="User Defined Warrant Numbers Preference"
        />
      </span>
    );
  };
  const renderDontPrintSSN = () => {
    const onChange = () => setDontPrintSSN(!dontPrintSSN);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={dontPrintSSN}
          onChange={onChange}
          label="Do not Print SSN or Incident Prints"
        />
      </span>
    );
  };
  const renderPrintArrest = () => {
    const onChange = () => setPrintArrestSign(!printArrestSign);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={printArrestSign}
          onChange={onChange}
          label="Print Arrest Signature Detail"
        />
      </span>
    );
  };
  const renderDontPrintPOB = () => {
    const onChange = () => setDontPrintPOB(!dontPrintPOB);
    return (
      <span className={classes.item}>
        <Checkbox2 checked={dontPrintPOB} onChange={onChange} label="Do Not Print Place of Birth" />
      </span>
    );
  };
  const renderCollegeAgency = () => {
    const onChange = () => setCollegeAgency(!collegeAgency);
    return (
      <span className={classes.item}>
        <Checkbox2 checked={collegeAgency} onChange={onChange} label="Enable Clery Reporting" />
      </span>
    );
  };
  const renderHideJuvInc = () => {
    const onChange = () => setHideJuvInc(!hideJuvInc);
    return (
      <span className={classes.item}>
        <Checkbox2 checked={hideJuvInc} onChange={onChange} label="Hide Juvenile Incidents" />
      </span>
    );
  };
  const renderEnableIncDef = () => {
    const onChange = () => setEnableIncDef(!enableIncDef);
    return (
      <span className={classes.item}>
        <Checkbox2 checked={enableIncDef} onChange={onChange} label="Enable Incidents Defaults" />
      </span>
    );
  };
  const renderEnableImpSelectAll = () => {
    const onChange = () => setEnableImportSelect(!enableImportSelect);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={enableImportSelect}
          onChange={onChange}
          label="Enable Import Select All"
        />
      </span>
    );
  };
  const renderEnablePrintOther = () => {
    const onChange = () => setEnablePrintOther(!enablePrintOther);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={enablePrintOther}
          onChange={onChange}
          label="Enable Print Other Party Details"
        />
      </span>
    );
  };
  const renderEnablePrintChoice = () => {
    const onChange = () => setEnablePrintChoice(!enablePrintChoice);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={enablePrintChoice}
          onChange={onChange}
          label="Enable Print Choice On Unapproved"
        />
      </span>
    );
  };
  const renderEnablePopup = () => {
    const onChange = () => setEnablePopup(!enablePopup);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={enablePopup}
          onChange={onChange}
          label="Enable Popup for Warrant on Insert"
        />
      </span>
    );
  };
  const renderAllowSupp = () => {
    const onChange = () => setAllowSupplement(!allowSupplement);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={allowSupplement}
          onChange={onChange}
          label="Allow Suppment Insert On Locked Incident"
        />
      </span>
    );
  };
  const renderDisableApprovalSign = () => {
    const onChange = () => setDisableApproval(!disableApproval);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={disableApproval}
          onChange={onChange}
          label="Disable Approval Signature On Selection Print"
        />
      </span>
    );
  };
  const renderReqArrestLocation = () => {
    const onChange = () => setRequireArrest(!requireArrest);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={requireArrest}
          onChange={onChange}
          label="Require Arrest Location From Address File"
        />
      </span>
    );
  };
  const renderRichText = () => {
    const onChange = () => setRichText(!richText);
    return (
      <span className={classes.item}>
        <Checkbox2 checked={richText} onChange={onChange} label="Rich Text For Narratives" />
      </span>
    );
  };
  const renderEnableOfficer = () => {
    const onChange = () => setEnableOfficer(!enableOfficer);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={enableOfficer}
          onChange={onChange}
          label="Enable Officer Involved Shooting Data"
        />
      </span>
    );
  };
  const renderOpenNarratives = () => {
    const onChange = () => setOpenNarratives(!openNarratives);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={openNarratives}
          onChange={onChange}
          label="Open Narratives In View Mode On Double Click"
        />
      </span>
    );
  };
  const renderEnableExpunge = () => {
    const onChange = () => setEnableExpunge(!enableExpunge);
    return (
      <span className={classes.item}>
        <Checkbox2 checked={enableExpunge} onChange={onChange} label="Enable Expunge Party" />
      </span>
    );
  };
  const renderEnableUnknownOffender = () => {
    const onChange = () => setEnableUnknown(!enableUnknown);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={enableUnknown}
          onChange={onChange}
          label="Enable Unknown Offender Button"
        />
      </span>
    );
  };
  const renderDisablePressRelease = () => {
    const onChange = () => setDisablePress(!disablePress);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={disablePress}
          onChange={onChange}
          label="Disable Press Release Property Print"
        />
      </span>
    );
  };
  const renderDisableAutoStatus = () => {
    const onChange = () => setDisableAutoStatus(!disableAutoStatus);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={disableAutoStatus}
          onChange={onChange}
          label="Disable Automatic Status Add"
        />
      </span>
    );
  };
  const renderOverridePrint = () => {
    const onChange = () => setOverridePrint(!overridePrint);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={overridePrint}
          onChange={onChange}
          label="Override Print With Local Ordinance"
        />
      </span>
    );
  };
  const renderExportToLegacyCitation = () => {
    const onChange = () => setAllowLegacyExport(!allowLegacyExport);
    return (
      <span className={classes.item}>
        <Checkbox2
          checked={allowLegacyExport}
          onChange={onChange}
          label="Allow Export To Legacy Citation "
        />
      </span>
    );
  };
  const renderSaveBtn = () => {
    return (
      <div className="text-right pb-3">
        <Button
          color="primary"
          variant="contained"
          onClick={handleSave}
          disabled={
            oriError ||
            citationExportError ||
            ((!dataBrokerBaseUrl?.trim() || !dataBrokerSecret?.trim() || !dataBrokerAccessId?.trim()) && dataBrokerEnabled)
          }>
          <SaveIcon className="mr-2" /> Save
        </Button>
      </div>
    );
  };

  return (
    <div className={classes.wrap}>
      {renderSaveBtn()}
      <Row>
        <ColCard minWidth={350}>
          {renderIncidentReportVersion()}
          {renderEvidenceLabelReportVersion()}
          {renderNibrsReporting()}
          {renderDAReportingSettings()}
        </ColCard>
        <ColCard minWidth={550}>{renderCitationVersion()}</ColCard>
        {/* <ColCard minWidth={300}>
          {renderShortForm()} 
          {renderCourtTitle()}
          {renderIbrReporting()}
        </ColCard>
        <ColCard minWidth={300}>
          {renderUcrRape()}
          {renderUcrHate()}
        </ColCard> */}
      </Row>
      <Row>
        <ColCard minWidth={300}>
          <RowInner>
            {renderShowImport()}
            {renderSharedNumbers()}
            {renderViewNarratives()}
            {renderImportDefault()}
          </RowInner>
          <RowInner>
            {renderUserDefWarrant()}
            {renderDontPrintSSN()}
            {renderPrintArrest()}
            {renderDontPrintPOB()}
          </RowInner>
          <RowInner>
            {renderCollegeAgency()}
            {renderHideJuvInc()}
            {renderEnableIncDef()}
            {renderEnableImpSelectAll()}
          </RowInner>
          <RowInner>
            {renderEnablePrintOther()}
            {renderEnablePrintChoice()}
            {renderEnablePopup()}
            {renderAllowSupp()}
          </RowInner>
          <RowInner>
            {renderDisableApprovalSign()}
            {renderReqArrestLocation()}
            {renderRichText()}
            {renderEnableOfficer()}
          </RowInner>
          <RowInner>
            {renderOpenNarratives()}
            {renderEnableExpunge()}
            {renderEnableUnknownOffender()}
            {renderDisablePressRelease()}
          </RowInner>
          <RowInner>
            {renderDisableAutoStatus()}
            {renderOverridePrint()}
          </RowInner>
        </ColCard>
      </Row>
    </div>
  );
}

export default connect(null, {
  handleError,
  notify,
})(AgencyRms);
